import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { takeUntil } from 'rxjs/operators';
import { ThemeEditorStoreService } from '../../theme-editor/theme-editor-store.service';
import { EditorInputField } from '../../../editor-container/editor-model';
import { ToggleSectionDirective } from './toggle-section.directive';
import { CssServicesService, ThemeVariables } from '../../../services/css-services.service';

@Component({
  selector: 'kve-theme-color-picker',
  templateUrl: './theme-color-picker.component.html',
  styleUrls: ['./theme-color-picker.component.scss']
})
export class ThemeColorPickerComponent implements OnInit,AfterViewInit,OnChanges {
  @Input()field:EditorInputField;
  fieldName:string;
  
  colors:string[] = [];

  color = "#FFF";
  primaryColor = "";

  themes = [
    {
      id:1,
      value: 'default',
      name: 'Default',
      pallette:'#3366ff',
    },
    {
      id:2,
      value: 'green-house',
      name: 'Green House',
      pallette:"#8CA52E"
    },
    {
      id:3,
      value: 'navy-kadet',
      name: 'Navy Kadet',
      pallette:"#192A53"
    },
    {
      id:4,
      value: 'earthtone',
      name: 'Earth Tone',
      pallette:"#B73225"
    },
    {
      id:5,
      value: 'makeup',
      name: 'Makeup',
      pallette:"#DDAF94"
    },
    {
      id:6,
      value: 'blackish',
      name: 'Blackish',
      pallette:"#202020"
    },
    {
      id:7,
      value: 'cactus',
      name: 'Cactus',
      pallette:"#74AC67"
    },
    {
      id:8,
      value: 'olive-tree',
      name: 'Olive Tree',
      pallette:"#77A19B"
    },
    {
      id:9,
      value: 'citric-acid',
      name: 'Citric Acid',
      pallette:"#FE7C02"
    },
    {
      id:10,
      value: 'wind-swept',
      name: 'Wind Swept',
      pallette:"#AB9390"
    },
    {
      id:11,
      value: 'fools-gold',
      name: 'Fools Gold',
      pallette:"#FFC507"
    },
    {
      id:12,
      value: 'skyroof',
      name: 'Skyroof',
      pallette:"#87CEEB"
    },
    {
      id:13,
      value: 'riding-hood',
      name: 'Ridinghood',
      pallette:"#FF0000"
    },
    {
      id:14,
      value: 'springboks',
      name: 'Sringboks',
      pallette:"#1C8A04"
    },
    {
      id:15,
      value: 'purple-rain',
      name: 'Purple Rain',
      pallette:"#FB03B8"
    },
    {
      id:16,
      value: 'egoli',
      name: 'Egoli',
      pallette:"#FFFF00"
    }
  ];

  themeVariables$:Subscription;
  pageBgColor$:Subscription;
  pageBgColor:string;
  bgColors$:Subscription;
  txtColor$:Subscription;
  textColor:string;
  bgColors:string[]=[];
  primaryColors$:Subscription;
  primaryColors:string[]=[];
  bgBasic:string[]=[];
  bgPrimary:string[]
  bgAlt:string[];
  allColors:string[]=[];
  destroy$ = new Subject<void>();

  selectedOption = "preset";

  option;

  pickerOptions = [
    {label:"Presets",value:"preset", name:"presetOption",checked: "true"},
    {label:"Custom",value:"custom", name:"presetOption"}
  ]

  firstOption:HTMLElement;
  toggleSections:HTMLCollection;

  @ViewChild('primaryColorPicker',{read:ElementRef}) primaryColorPicker:ElementRef<HTMLElement>
  @ViewChild('optionPicker',{read:ElementRef}) optionPicker:ElementRef<HTMLElement>
  @ViewChild(ToggleSectionDirective) togglePickers;

  @Output() updateField: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private cssService:CssServicesService,
    private communicator: IframeCommunicationService,
    private themeEditorStore:ThemeEditorStoreService) { }


  ngOnInit(): void {
    console.log("Init called ....")
    this.themes.forEach(theme => {
      this.colors.push(theme.pallette);
    })
    console.log(this.colors);
    this.themeVariables$ = this.cssService.getThemeVariables().subscribe((data:any) => {
      console.log(data);
      let themeVariables = data.variables;
      this.color = themeVariables["primary"];
      console.log(this.color)
      /* for (let [k,v] of Object.entries(themeVariables)) {
        if(k == "primary"){
          console.log(k,v);
        };
      } */
    })
    
    this.bgColors$ = this.cssService.getBgColors().subscribe((data:any) => {
        console.log(data);
        //this._bgColors = [];
        for (let [k,v] of Object.entries(data)) {
            console.log(<string>v["val"]);
            //this._bgColors.push(<string>v["val"]);
            this.bgColors.push(<string>v["val"]);
            this.bgBasic.push(<string>v["val"]);
          }
          this.bgBasic = this.bgColors.splice(0,3)
          this.bgPrimary = this.bgColors.splice(0,4)
          this.bgAlt = this.bgColors.splice(0,4)

          console.log({Basic:this.bgBasic})
          console.log({Primary:this.bgPrimary})
          console.log({Alt:this.bgAlt})
    })
    /* this.bgColors$ = this.communicator.receive("backgrounds").pipe(takeUntil(this.destroy$))
    .subscribe((data:any) => {
      console.log(data);
      this._bgColors = [];
      for (let [k,v] of Object.entries(data.data.options)) {
          this._bgColors.push(<string>v);
        }
        this.bgBasic = this._bgColors.splice(0,4)
        this.bgPrimary = this._bgColors.splice(0,4)
        this.bgAlt = this._bgColors.splice(0,4)
        console.log({Basic:this.bgBasic})
        console.log({Primary:this.bgPrimary})
        console.log({Alt:this.bgAlt})
    }) */
    this.primaryColors$ = this.cssService.getPmColors().subscribe((data:any) => {
      console.log(data);
      //this._primaryColors = [];
      for (let [k,v] of Object.entries(data)) {
          this.primaryColors.push(<string>v["val"]);
        }
        console.log(this.primaryColors);
        this.primaryColor = this.primaryColors[4];
        this.color = this.primaryColors[4];
        this.allColors = this.bgBasic.concat(this.primaryColors,this.bgAlt);
    })
    /* this.primaryColors$ = this.communicator.receive("colorScheme").pipe(takeUntil(this.destroy$))
    .subscribe((data:any) => {
      console.log(data);
      this._primaryColors = [];
      for (let [k,v] of Object.entries(data.data.options)) {
          this._primaryColors.push(<string>v);
        }
        console.log(this._primaryColors);
        this.primaryColor = this._primaryColors[4];
        this.color = this._primaryColors[4];
    }) */
    this.pageBgColor$ = this.communicator.receive("pageBgColor").pipe(takeUntil(this.destroy$))
    .subscribe((payload:any) => {
      //console.log(data);
      this.pageBgColor = payload.data;
    })
    this.txtColor$ = this.communicator.receive("txtColor").pipe(takeUntil(this.destroy$))
    .subscribe((payload:any) => {
      console.log(payload);
      this.textColor = payload.data;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["field"]){
      console.log(this.field)
      this.fieldName = this.field.name;
      console.log({color:this.color});
      console.log({Basic:this.bgBasic})
      console.log({Primary:this.bgPrimary})
      console.log({Alt:this.bgAlt})
      this.communicator.receive("themeVariables").subscribe((data:any) => {
        console.log(data);
      })
    }
  }

  ngAfterViewInit(): void {
    /* this.firstOption = <HTMLElement>this.optionPicker.nativeElement.querySelector('.inner-circle');
    if(this.firstOption != undefined){
      this.firstOption.style.setProperty("background-color","var(--radio-basic-focus-inner-circle-color)");
    }else{
      console.log("fokof Almal")
    } */
    /* setTimeout(() => {
      console.log(this.primaryColorPicker);
      let picker = this.primaryColorPicker.nativeElement.querySelector('.sketch-picker');
      if(picker != undefined){
        this.toggleSections = picker.children;
        this.togglePickerSections("none");
      }
    }, 500); */
      

  }

  onChangeOption(e){
    this.togglePickers.onChangeOption(e);
    /* if(e == "custom"){
      this.firstOption.style.setProperty("background-color","");
      this.togglePickerSections("block");
    }else{
      this.togglePickerSections("none");
    } */
  }
  handleColorPick(e){
    console.log(e)
    console.log(this.field);
    /* this.themes.forEach(theme => {
      console.log(theme.pallette.toLowerCase())
    }) */
    switch (this.field.name) {
      case "primaryColor":
        let selectedTheme = this.themes.find(theme => theme.pallette.toLowerCase() == e.color.hex.toLowerCase());
        this.color = e.color.hex;
        this.themeEditorStore.updateThemeName(selectedTheme.value)
        break;
      case "background":
        this.field.value = e.color.hex;
        this.updateField.emit(this.field);
        break;
    
      default:
        break;
    }

    
    //console.log(selectedTheme)
  }
  handleChangeComplete(e){
    /* let color = e.color.hex;
    console.log(color);
    let selectedTheme = this.themes.find(theme => theme.pallette == color);
    console.log(selectedTheme.name);
    if(selectedTheme != undefined && selectedTheme != null){
      console.log(selectedTheme.name);            
    } */
  }

  /* togglePickerSections(mode:string){
    for(let i = 0 ; i < this.toggleSections.length; i++){
      let sectionElement = <HTMLElement>this.toggleSections[i];
      if(sectionElement.classList.contains('sketch-saturation') || sectionElement.classList.contains('sketch-controls') || sectionElement.classList.contains('sketch-fields-container')){
        sectionElement.style.setProperty('display',mode);
      }
    }
  } */

  handleBgChange(e){
    this.pageBgColor = e.color.hex;
    //this.communicator.sendFromParent({id:"pageBgColor",data:this.pageBgColor});
    this.field.value = e.color.hex;
    this.updateField.emit(this.field);
  }

  handleTxtChange(e){
    console.log(e);
    this.textColor = e.color.hex;
    this.communicator.sendFromParent({id:"txtColor",data:this.textColor});
  }

  changeComplete(e){

  }



}
